window.mixins = [];
import '../custom/vue/main';
